// extracted by mini-css-extract-plugin
module.exports = {"MainWrapper":"Orders_MainWrapper__LL6-a"};